import React from 'react';

function PointsOfPerformanceEmpty() {
    return (
        <div className="points-of-performance-container">
            <div className="points-of-performance-header points-of-performance-header--static">
                <span className="points-of-performance-label">
                    Points of Performance
                </span>
            </div>
            <p className="exercise-preview-empty">No points of performance.</p>
        </div>
    );
}

export default PointsOfPerformanceEmpty;



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/PointsOfPerformanceEmpty.jsx